import React, { ReactNode } from 'react';
import cn from 'classnames';

import styles from './ApprovalUnitsInfoRow.module.scss';

interface IApprovalUnitsInfoRow {
	title: string;
	info?: string | number;
	leftIcon?: ReactNode;
	isAlignCenter?: boolean;
}

const ApprovalUnitsInfoRow = ({
	title,
	info,
	leftIcon,
	isAlignCenter,
}: IApprovalUnitsInfoRow) => {
	return (
		<div className={cn(styles.infoContainer, {
			[styles.alignCenter]: isAlignCenter,
		})}>
			<div className={cn(styles.title, {
				[styles.alignCenterTitle]: isAlignCenter,
			})}>
				{`${title}:`}&nbsp;
			</div>
			<div className={styles.info}>
				<div className={styles.leftIcon}>
					{leftIcon}
				</div>
				<span>{info}</span>
			</div>
		</div>
	);
};

export default ApprovalUnitsInfoRow;
